import React from 'react';
import classnames from 'classnames';
import styles from './noAssociationsPlaceholder.module.scss';
import AddAssociationButton from 'v2/common/DRM/AddAssociationButton/AddAssociationButton';
import noAssociationsImage from 'v2/images/noAssociationsImage.png';

interface NoAssociationsPlaceholderProps {
  onButtonClick?: () => void;
  buttonLabel?: string;
  image?: string;
  fitContentBtn?: boolean;
  message?: string;
}

const NoAssociationsPlaceholder = ({
  onButtonClick,
  buttonLabel,
  image,
  fitContentBtn,
  message,
}: NoAssociationsPlaceholderProps) => {
  return (
    <div className={classnames(styles.noAssociationsContainer)}>
      <img src={image || noAssociationsImage} alt="no-associations" />
      <p
        data-cy="noassociations:placeholder"
        className={classnames(styles.noAssociationsFoundText)}
      >
        {message || `You haven't created any records, create one now.`}
      </p>
      {onButtonClick && buttonLabel && (
        <AddAssociationButton
          onClick={onButtonClick}
          label={buttonLabel}
          fitContentBtn={fitContentBtn}
        />
      )}
    </div>
  );
};

export default NoAssociationsPlaceholder;
